// extracted by mini-css-extract-plugin
export default {"_hy":"_hy","root":"navItem-module_root_tKq","priceClub":"navItem-module_priceClub_KPO"};